import OpsProcesses from "./OpsProcesses"

export default OpsProcesses
